/**
 * Identyfikator wersji kodu, z którego zbudowano aplikację (skrót commita; wstawia go `vite build` przez `define`, patrz `vite.config.ts`).
 * Zapisuje się go przy nagraniach do strojenia (SPEC §23.40), żeby wiedzieć, jaki kod i jakie progi wydały werdykt. Poza buildem (testy, `tsc`) to `dev`.
 */
declare const __BUILD_ID__: string | undefined;

export const BUILD_ID: string = typeof __BUILD_ID__ === 'string' && /^[A-Za-z0-9._+-]{1,40}$/.test(__BUILD_ID__) ? __BUILD_ID__ : 'dev';
